import styled, { css } from "styled-components";

export const StyledLoader = styled.div`
  @keyframes wait-animation-s {
    0% {
      opacity: 0;
    }
    99% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  animation: wait-animation-s -1ms 800ms ease-in;

  @keyframes slide {
    0% {
      transform: translate(0, 0);
    }
    2% {
      transform: translate(${({ $widthEl }) => $widthEl}px, 0);
    }
    12.5% {
      transform: translate(${({ $widthEl }) => $widthEl}px, 0);
    }
    15.5% {
      transform: translate(${({ $widthEl }) => 2 * $widthEl}px, 0);
    }
    25% {
      transform: translate(${({ $widthEl }) => 2 * $widthEl}px, 0);
    }
    27% {
      transform: translate(
        ${({ $widthEl }) => 2 * $widthEl}px,
        ${({ $widthEl }) => $widthEl}px
      );
    }
    37.5% {
      transform: translate(
        ${({ $widthEl }) => 2 * $widthEl}px,
        ${({ $widthEl }) => $widthEl}px
      );
    }
    39.5% {
      transform: translate(
        ${({ $widthEl }) => $widthEl}px,
        ${({ $widthEl }) => $widthEl}px
      );
    }
    50% {
      transform: translate(
        ${({ $widthEl }) => $widthEl}px,
        ${({ $widthEl }) => $widthEl}px
      );
    }
    52% {
      transform: translate(
        ${({ $widthEl }) => $widthEl}px,
        ${({ $widthEl }) => 2 * $widthEl}px
      );
    }
    62.5% {
      transform: translate(
        ${({ $widthEl }) => $widthEl}px,
        ${({ $widthEl }) => 2 * $widthEl}px
      );
    }
    64.5% {
      transform: translate(0, ${({ $widthEl }) => 2 * $widthEl}px);
    }
    75% {
      transform: translate(0, ${({ $widthEl }) => 2 * $widthEl}px);
    }
    77% {
      transform: translate(0, ${({ $widthEl }) => $widthEl}px);
    }
    87.5% {
      transform: translate(0, ${({ $widthEl }) => $widthEl}px);
    }
    89.5% {
      transform: translate(0, 0);
    }
    100% {
      transform: translate(0, 0);
    }
  }
  @keyframes gradient1 {
    from {
      stop-color: #4383b8;
    }
    50% {
      stop-color: #8013b9;
    }
    to {
      stop-color: #4383b8;
    }
  }
  @keyframes gradient2 {
    from {
      stop-color: #4aa06c;
    }
    50% {
      stop-color: #b22358;
    }
    to {
      stop-color: #4aa06c;
    }
  }
  @keyframes rotate {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  ${({ $inBtn }) =>
    $inBtn
      ? css`
          position: absolute;
          top: -25px;
          left: calc(50% - 10px);
        `
      : ""}
`;

export const LoaderContainer = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;

  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
`;
